// -- React Libraries
import React from 'react';

// -- Styles
import StyleWrapper from "./Wrapper";

// -- Resources
import Tick from "../../../../image/aos-tick.png";
import Cross from "../../../../image/aos-cross.png";

export default class GridHeader extends React.Component {
    render() {
        return (
            <StyleWrapper className="grid-header">
                <div className="header-text">{this.props.title}</div>
                <div className="header-explain">{this.props.children}</div>
                <div className="header-icon">
                    <img src={
                        this.props.ok && Tick || Cross
                    }/>
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridHeader/index.js